import { Fragment, useCallback, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ScreenReaderAnnouncer } from 'marketplace-ui-common/components/accessibility/ScreenReaderAnnouncer';
import { useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewWizardSubmitSection({
  buttonProps,
  showLegalCheckbox = true
}) {
  const {
    onClick
  } = buttonProps;
  const {
    customValidationErrors,
    validationErrors
  } = useReviewContext();
  const [checkedLegalDisclaimer, setCheckedLegalDisclaimer] = useState(false);
  const [showLegalTooltip, setShowLegalTooltip] = useState(false);
  const handleSubmitClick = useCallback(e => {
    if (showLegalCheckbox && !checkedLegalDisclaimer) {
      setShowLegalTooltip(true);
    } else if (onClick) {
      onClick(e);
    }
  }, [checkedLegalDisclaimer, onClick, showLegalCheckbox]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showLegalCheckbox && /*#__PURE__*/_jsx(ScreenReaderAnnouncer, {
      announcedText: showLegalTooltip ? unescapedText('trellisEcosystem.reviews.legalTooltip') : '',
      use: "assertive"
    }), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "row",
      justify: "end",
      children: [showLegalCheckbox && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          className: "m-right-2",
          id: "disclaimer-text",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            elements: {
              Link: UILink
            },
            message: "trellisEcosystem.reviews.legal_jsx",
            options: {
              href: 'https://legal.hubspot.com/review-guidelines',
              external: true
            }
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          open: showLegalTooltip,
          title: unescapedText('trellisEcosystem.reviews.legalTooltip'),
          children: /*#__PURE__*/_jsx(UICheckbox, {
            "aria-labelledby": "disclaimer-text",
            checked: checkedLegalDisclaimer,
            className: "m-right-7",
            onChange: ({
              target: {
                checked
              }
            }) => {
              setShowLegalTooltip(false);
              setCheckedLegalDisclaimer(checked);
            }
          })
        })]
      }), /*#__PURE__*/_jsx(UITooltip, {
        title: customValidationErrors[0],
        children: /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
          disabled: validationErrors.length > 0 || customValidationErrors.length > 0,
          onClick: handleSubmitClick
        }))
      })]
    })]
  });
}